/**
 * 주어진 시간(ms)만큼 대기하는 프로미스를 생성한다.
 * @example
 * const resultOrTimeOut = Promise.race([actions.fetch(), waitFor(2500)]);
 */
export const waitFor = (amount: number): Promise<void> => new Promise<void>(res => setTimeout(res, amount));
